<template>
  <div>
    <el-dialog
      class="pop-connect-dialog"
      :visible.sync="dialogShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
      width="72%"
      :title="$t('pop.connetSelect')"
    >
      <div class="pop-connect-contain clearfix">
        <div class="pop-connect-lf">
          <div
            :class="['pop-connect-card', { active: type === item.value }]"
            v-for="(item, index) in typeList"
            :key="'type' + index"
            @click="changeType(item.value)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="pop-connect-lr">
          <div class="connect-search clearfix">
            <el-row>
              <el-col :span="20">
                <div class="search-module clearfix" v-if="type === 1">
                  <span class="search-module-name">{{ $t("couse.coursename") }}</span>
                  <span class="search-module-value">
                <el-input v-model="courseName" clearable></el-input>
              </span>
                </div>
                <div class="search-module clearfix" v-if="type === 2">
                  <span class="search-module-name">{{ $t("pop.dataName") }}</span>
                  <span class="search-module-value">
                <el-input v-model="dataName" clearable></el-input>
              </span>
                </div>
                <div class="search-module clearfix" v-if="type === 5">
                  <span class="search-module-name">{{ $t("pop.courseType5") }}</span>
                  <span class="search-module-value">
                <el-input v-model="courseType5" clearable></el-input>
              </span>
                </div>
                <div class="search-module clearfix" v-if="type === 4">
                  <span class="search-module-name">{{ $t("pop.mukeName") }}</span>
                  <span class="search-module-value">
                <el-input v-model="mukeName" clearable></el-input>
              </span>
                </div>
                <div class="search-module clearfix" v-if="type === 6">
                  <span class="search-module-name">{{ $t("pop.live") }}</span>
                  <span class="search-module-value">
                <el-input v-model="live" clearable></el-input>
              </span>
                </div>
                <div class="search-module clearfix" v-if="type === 7">
                  <span class="search-module-name">{{ $t("pop.zhihu") }}</span>
                  <span class="search-module-value">
                <el-input v-model="searchName" clearable></el-input>
              </span>
                </div>
                <!--团队-->
                <div class="search-module" v-if="type !== 7">
                  <span class="search-module-name">{{ $t("pop.team") }}</span>
                  <span class="search-module-value">
                <el-select v-model="team">
                  <el-option
                          v-for="item in teamList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                  >
                  </el-option>
                </el-select>
              </span>
                </div>
                <!--知乎分类-->
                <div class="search-module" v-if="type === 7">
                  <span class="search-module-name">类型</span>
                  <span class="search-module-value">
                    <el-select v-model="queryType">
                      <el-option
                          v-for="item in queryTypeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </span>
                </div>
                <!--创建人-->
                <div class="search-module" v-if="type !== 7">
                  <span class="search-module-name">{{ $t("pop.creatorTitle") }}</span>
                  <span class="search-module-value">
                    <el-input v-model="creator" clearable></el-input>
                  </span>
                </div>
                <!--提交人-->
                <div class="search-module" v-if="type === 7">
                  <span class="search-module-name">{{ $t("pop.userName") }}</span>
                  <span class="search-module-value">
                    <el-input v-model="creator" clearable></el-input>
                  </span>
                </div>
              </el-col>

              <el-col :span="4">
                <!--查询-->
                <div class="search-module" @click="searchData">
                  <el-button class="tool-button tool-button-push" type="primary">
                    {{ $t("query") }}
                  </el-button>
                </div>
                <!--重置-->
                <div class="search-module" @click="resetData">
                  <el-button class="tool-button tool-button-push el-back" type="info">
                    {{ $t("reset") }}
                  </el-button>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- 微课 资料 慕课  混合式学习 直播 -->
          <div class="connect-list" v-if="type !== 7">
            <el-table
              v-loading="dataListLoading"
              :data="dataList"
              ref="singleTable"
              border
              class="jySelectionAll"
              @select="handleSelectionChange"
              style="width: 100%"
            >
              <!-- 选择框 -->
              <el-table-column type="selection" align="center" fixed="left">
              </el-table-column>
              <el-table-column
                prop="courseCode"
                :label="$t('pop.id')"
                header-align="center"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="courseName"
                :label="$t('process.name')"
                header-align="center"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="creatDate"
                :label="$t('pop.createTime')"
                header-align="center"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                prop="pubDate"
                :label="$t('pop.publishTime')"
                header-align="center"
                :show-overflow-tooltip="true"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="teamTypeDesc"
                :label="$t('pop.team')"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="creatBy"
                :label="$t('pop.creatorTitle')"
                header-align="center"
                align="center"
                :show-overflow-tooltip="true"
              ></el-table-column>
            </el-table>
          </div>

          <!-- 知乎 -->
          <div class="connect-list" v-if="type === 7">
            <el-table
                    v-loading="dataListLoading"
                    :data="dataList"
                    ref="singleTable"
                    border
                    class="jySelectionAll"
                    @select="handleSelectionChange"
                    @select-all="selectAll"
                    style="width: 100%"
            >
              <!-- 选择框 -->
              <el-table-column type="selection" align="center" fixed="left">
              </el-table-column>
              <el-table-column
                      prop="typeText"
                      :label="$t('pop.typeText')"
                      header-align="center"
                      align="center"
                      :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                      prop="title"
                      :label="$t('pop.title')"
                      header-align="center"
                      align="center"
                      :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                      prop="brand"
                      :label="$t('pop.brand')"
                      header-align="center"
                      :show-overflow-tooltip="true"
                      align="center"
                      :formatter="brandText"
              ></el-table-column>
              <el-table-column
                      prop="orgName"
                      :label="$t('pop.orgName')"
                      header-align="center"
                      align="center"
                      :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                      prop="userName"
                      :label="$t('pop.userName')"
                      header-align="center"
                      align="center"
                      :show-overflow-tooltip="true"
              ></el-table-column>
              <el-table-column
                      prop="createTime"
                      :label="$t('pop.createTimes')"
                      header-align="center"
                      align="center"
                      :show-overflow-tooltip="true"
              ></el-table-column>
            </el-table>
          </div>

          <el-pagination
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle"
          >
          </el-pagination>
          <div class="pop-connect-footer">
            <el-button
              class="tool-button tool-button-info"
              type="info"
              @click="handleClose"
            >
              {{ $t("course.cancel") }}
            </el-button>
            <el-button class="tool-button" type="primary" @click="saveRelative">
              {{ $t("pop.chose") }}
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
    },
    popType: {
      type: Number,
    },
  },
  data() {
    return {
      creator: "",
      team: "",
      dataName: "",
      courseName: "",
      mukeName: "",
      courseType5: "",
      live: "",
      searchName: "", // 知乎查询 标题
      queryType: 0, // 知乎查询 分类
      dataList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      type: 0,
      teamList: [],
      queryTypeList: [
        { label: this.$t("pop.queryType1"), value: 0 },
        { label: this.$t("pop.queryType2"), value: 1 },
        { label: this.$t("pop.queryType3"), value: 2 },
        { label: this.$t("pop.queryType4"), value: 4 },
      ], // 知乎类型
      dataListLoading: false,
      typeList: [
        { name: this.$t("pop.courseType1"), value: 1 },
        { name: this.$t("pop.courseType2"), value: 2 },
        { name: this.$t("pop.courseType4"), value: 4 },
        { name: this.$t("pop.courseType5"), value: 5 },
        { name: this.$t("pop.courseType6"), value: 6 },
        { name: this.$t("pop.courseType7"), value: 7 },
      ],
    };
  },
  watch: {
    popType() {
      switch (this.popType) {
        case 5:
          this.type = 1;
          break;
        case 9:
          this.type = 2;
          break;
        case 12:
          this.type = 4;
          break;
        case 30:
          this.type = 5;
          break;
        case 65:
          this.type = 6;
          break;
        case 36:
          this.type = 7;
          break;
        default:
          this.type = 0;
          break;
      }
    },
  },
  methods: {
    changeType(val) {
      this.type = val;
      this.pageSize = 10;
      this.pageNum = 1;
      this.total = 0;
      this.dataList = [];
      this.getDataList();
      this.$emit("backType", this.type);
    },
    handleClose() {
      this.$emit("closeHandle", false);
    },
    pageSizeChangeHandle(val) {
      this.pageNum = 1;
      this.pageSize = val;
      this.getDataList();
    },
    pageCurrentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    // table Checkbox方法
    handleSelectionChange(selection, row) {
      this.$refs.singleTable.clearSelection();
      this.multipleSelection = [];
      if (selection.length === 0) {
        // 判断selection是否有值存在
        return;
      }
      if (row) {
        this.$refs.singleTable.toggleRowSelection(row, true);
        this.multipleSelection.push(row);
      }
    },
    selectAll(selection, row) {
      this.$refs.singleTable.clearSelection()
    },
    // 查看数据
    getDataList() {
      const params = {
        pageNo: this.pageNum,
        pageSize: this.pageSize,
        creatBy: this.creator,
        teamType: this.team,
      };
      this.dataList = [];
      this.dataListLoading = true;
      switch (this.type) {
        case 1:
          params.courseName = this.courseName;
          this.getCourse(params);
          break;
        case 2:
          params.docSearchName = this.dataName;
          this.getDocument(params);
          break;
        case 4:
          params.courseName = this.mukeName;
          this.getMooc(params);
          break;
        case 5:
          params.courseName = this.courseType5;
          this.getMixed(params);
          break;
        case 6:
          params.broadcastName = this.live;
          this.getLive(params);
          break;
        case 7:
          params.searchName = this.searchName;
          params.queryType = this.queryType;
          this.getzhihu(params);
          break;
        default:
          break;
      }
    },
    searchData() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getDataList();
    },
    // 重置
    resetData() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.creator= "",
      this.team = '';
      this.courseName = '';
      this.dataName = '';
      this.mukeName = '';
      this.courseType5 = '';
      this.live = '';
      this.searchName = '';
      this.queryType = 0;
      this.getDataList();
    },
    formDateTime(val) {
      let date = new Date(val * 1);
      let year = date.getFullYear();
      let month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
      let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      let minute = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return `${year}-${month}-${day} ${hour}:${minute}:${seconds}`;
    },
    // 微课查询
    getCourse(params) {
      this.$request
        .post("/sys/popsUpMsg/listCourse", params)
        .then((res) => {
          if (res) {
            this.total = res.totalCount;
            this.dataList = res.data.map((item) => {
              Object.assign(item, {
                creatDate: this.formDateTime(item.creatDate),
			    pubDate: item.pubDate == undefined  || item.pubDate == null ? "-" : this.formDateTime(item.pubDate),
              });
              return item;
            });
            this.dataListLoading = false;
          }
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    // 资料
    getDocument(params) {
      this.$request
        .post("/sys/popsUpMsg/listDocument", params)
        .then((res) => {
          if (res) {
            this.total = res.totalCount;
            this.dataList = res.data.map((item) => {
              Object.assign(item, {
                courseCode: item.docCode,
                courseName: item.docName,
                creatDate: this.formDateTime(item.creatDate),
			    pubDate: item.docPubDate == undefined  || item.docPubDate == null ? "-" : this.formDateTime(item.docPubDate),
              });
              return item;
            });
            this.dataListLoading = false;
          }
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    // 慕课查询
    getMooc(params) {
      this.$request
        .post("/sys/popsUpMsg/listMooc", params)
        .then((res) => {
          if (res) {
            this.total = res.totalCount;
            this.dataList = res.data.map((item) => {
              Object.assign(item, {
                creatDate: this.formDateTime(item.creatDate),
				pubDate: item.pubDate == undefined  || item.pubDate == null ? "-" : this.formDateTime(item.pubDate),
              });
              return item;
            });
            this.dataListLoading = false;
          }
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    // 混合式学习
    getMixed(params) {
      this.$request.post("/sys/popsUpMsg/listMixed", params).then((res) => {
        if (res) {
          this.total = res.totalCount;
          this.dataList = res.data.map((item) => {
            Object.assign(item, {
              creatDate: this.formDateTime(item.creatDate),
			  pubDate: item.pubDate == undefined  || item.pubDate == null ? "-" : this.formDateTime(item.pubDate),
            });
            return item;
          });
          this.dataListLoading = false;
        }
      });
    },
    // 直播查询
    getLive(params) {
      this.$request
        .post("/sys/popsUpMsg/listBroadcast", params)
        .then((res) => {
          if (res) {
            this.total = res.totalCount;
            this.dataList = res.data.map((item) => {
              Object.assign(item, {
                courseCode: item.broadcastCode,
                courseName: item.broadcastName,
                creatDate: item.createAt ? this.formDateTime(item.createAt) : "",
                creatBy: item.createName,
                pubDate: item.publishAt ? this.formDateTime(item.publishAt) : "",
              });
              return item;
            });
            this.dataListLoading = false;
          }
        })
        .catch(() => {
          this.dataListLoading = false;
        });
    },
    // 知乎查询
    getzhihu(params) {
      this.$request
              .post("/sys/popsUpMsg/listManage", params)
              .then((res) => {
                if (res) {
                  this.total = res.total;
                  this.dataList = res.records
                  this.dataListLoading = false;
                }
              })
              .catch(() => {
                this.dataListLoading = false;
              });
    },
    //  新增获取类型
    getDic() {
      this.$request.post("/sys/popsUpMsg/initCreate").then((res) => {
        if (res) {
          let data = res.listTeamTypeVO || [];
          this.teamList = [{ label: "全部", value: "" }].concat(data);
        }
      });
    },
    saveRelative() {
      this.$emit("saveRelative", this.multipleSelection);
    },

    brandText(row, column, cellValue){
      var brandCode = this.enums['brandCode']
      var brandStr = []
      var brandList = cellValue.split(",")
      brandList.forEach(item=>{
        brandCode.forEach(val=>{
          if (item === val.code){
            brandStr.push(val.name)
          }
        })
      })
      return brandStr.join(',')
    }
  },
  mounted() {
    this.getDic();
    switch (this.popType) {
      case 5:
        this.type = 1;
        break;
      case 9:
        this.type = 2;
        break;
      case 12:
        this.type = 4;
        break;
      case 30:
        this.type = 5;
        break;
      case 65:
        this.type = 6;
        break;
      case 36:
        this.type = 7;
        break;
      default:
        this.type = 0;
        break;
    }
    this.getDataList();
  },
};
</script>
<style lang="scss">
.pop-connect-dialog {
  .pop-connect-contain {
    display: flex;
  }
  .pop-connect-lf {
    width: 91px;
    margin-right: 20px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      right: -10px;
      top: 0;
      height: 100%;
      border-right: 1px dashed #dcdfe6;
    }
    .pop-connect-card {
      border: solid 1px #66c5b1;
      text-align: center;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
      cursor: pointer;
      margin-bottom: 12px;
      &.active {
        background-color: #66c5b1;
        color: #ffffff;
      }
      &:hover {
        background-color: #66c5b1;
        color: #ffffff;
      }
    }
  }
  .pop-connect-lr {
    flex: 1;
    .connect-search {
      margin-bottom: 20px;
      .search-module {
        height: 34px;
        line-height: 34px;
        float: left;
        margin-right: 20px;
        margin-bottom: 12px;
        .search-module-name {
          display: block;
          float: left;
          height: 100%;
          text-align: left;
          width: 70px;
        }
        .search-module-value {
          display: block;
          float: left;
          height: 100%;
          margin-left: 10px;
        }
      }
    }
    .pop-connect-footer {
      text-align: center;
      margin-top: 30px;
    }
  }
}
  .el-table__fixed-header-wrapper {
    display: none;
  }
</style>
